import { useCallback, useRef } from 'react';
import type { RefCallback } from 'react';

const elements = new Set<HTMLElement>();
const listeners = new Set<() => void>();

export const getAvoidElements = (): ReadonlySet<HTMLElement> => elements;

export function subscribeAvoidElements(listener: () => void): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

/** A ref for the root of a control pinned near the bottom of the page. The notification stack stays above it. */
export function useNotificationAvoid(): RefCallback<HTMLElement> {
  const current = useRef<HTMLElement | null>(null);

  return useCallback((element: HTMLElement | null) => {
    if (current.current === element) return;
    if (current.current) elements.delete(current.current);
    current.current = element;
    if (element) elements.add(element);
    listeners.forEach((listener) => listener());
  }, []);
}
